export default __webpack_public_path__ + "/dist/images/Buyer_page_english_en.8459392587fb9ba712596d11e1276ec4.jpeg";